import { useLinkedContext } from '@context/LinkedItemZoneContext'
import { useAppStore } from '@store'
import { Store, Textures } from '@types'
import { handleConcatStrings } from '@utils/handleConcatStrings'
import clsx from 'clsx'
import { ReactNode, useMemo } from 'react'
import cleanPrefixAndSuffixes from '@context/utils/linked/cleanPrefixAndSuffixes'
// import copy from '../../../assets/copiar.png'
// import copyImage from '../../../assets/copiar_gris.png'
// import paste from '../../../assets/pegar.png'
// import pasteImage from '../../../assets/pegar_gris.png'

type Props = { children?: ReactNode }
// const dictionary = {
//   cantCopy: copyImage,
//   canCopy: copy,
//   canPaste: paste,
//   cantPaste: pasteImage,
// }

export function LinkedObjectZonesEditor({ children }: Props) {
  const textos = useAppStore.use.textos()
  function t(str: string) {
    if (!textos.textos) return str
    if (!(str in textos.textos)) return str
    const str2 = str as unknown as keyof Store['textos']['textos']
    return textos.textos[str2]
  }

  const {
    object,
    setHighlighted,
    setIsModel,
    highlighted,
    // pasteIcons,
    setCopiedTexture,
    // selectedTexture,
    setIamUp,
    actions: { handleZoneClick },
  } = useLinkedContext()

  function handlePropertyClick(property: Textures[number]) {
    setHighlighted(handleConcatStrings(object.current.id, property.zoneName))
    setCopiedTexture(null)
    handleZoneClick(property)
    setIsModel(false)
    // resetCopyAndPaste()
    setIamUp(false)
  }

  const processedTextures = useMemo(() => {
    if (!object.current || !object.current.textures) {
      return []
    }

    const isDecoItem =
      String(object.current.catalogID || '').includes('DECO') ||
      object.current.referencia?.includes('DECO')

    // Detectar si es una vitrina
    const catalogID = String(object.current.catalogID || '').toUpperCase()
    const puertaTexture = object.current.textures?.find((t: any) => t.zoneDisplayName === 'Puerta')
    const modelo = puertaTexture?.modelo?.toLowerCase() ?? ''
    const isVitrina =
      modelo.includes('vitrina') ||
      catalogID.startsWith('KABV') ||
      catalogID.startsWith('KAPV') ||
      catalogID.startsWith('PE KABV') ||
      catalogID.startsWith('PE KAPV')

    const uniqueMap = new Map<string, Textures[number]>()

    for (const texture of object.current.textures || []) {
      if (!texture.modelo || !texture.acabado) continue

      if (texture.zoneDisplayName === 'Armazon' && !isDecoItem) continue

      // Filtrar texturas de vitrinas en unidades MBJ (no vitrinas)
      if (!isVitrina && texture.modelo === 'Vitrina') {
        continue
      }

      if (
        texture.zoneDisplayName === 'Patas' ||
        texture.zoneDisplayName === 'Rejilla' ||
        texture.zoneDisplayName === 'Campana' ||
        texture.zoneDisplayName === 'Detalle' ||
        texture.zoneDisplayName === 'Numeros' ||
        texture.zoneDisplayName === 'Logo' ||
        texture.zoneDisplayName === 'Filtros' ||
        texture.zoneDisplayName === 'Inox' ||
        texture.zoneDisplayName === 'Luz'
      ) {
        continue
      }

      if (!uniqueMap.has(texture.zoneDisplayName)) {
        uniqueMap.set(texture.zoneDisplayName, texture)
      }
    }

    const result = Array.from(uniqueMap.values())

    return result
  }, [
    object.current?.id,
    object.current?.textures?.length,
    object.current?.textures,
    object.current?.catalogID,
    object.current?.referencia,
    highlighted, // Añadir highlighted para forzar recálculo cuando cambia el objeto
  ])

  // if (!pasteIcons) return null

  return (
    <>
      <div className='h-[28px] bg-C/Color4 pl-2 pt-1'>{'Unidad principal'}</div>
      <div className='ml-2 h-[30px] pl-4 font-bold'>
        {cleanPrefixAndSuffixes(object.current.catalogID)}
      </div>
      <article className='flex flex-col'>
        <div
          className={clsx(
            object?.current.type === 'linkedItem' && 'scrollable-editor h-[165px] overflow-y-auto',
          )}
        >
          {processedTextures.map((texture: Textures[number], i: number) => {
            // const pasteIcon =
            //   pasteIcons[texture.zoneDisplayName] || pasteIcons[texture.zone] || 'cantPaste'

            return (
              <div
                key={i}
                onClick={() => {
                  handlePropertyClick(texture)
                }}
                className={clsx(
                  'h-[30px] cursor-pointer p-0.5 pl-14',
                  `${object.current.id}!${texture.zoneName}` === highlighted && 'bg-C/Color2 pt-1',
                )}
              >
                <div className='flex text-ellipsis whitespace-nowrap'>
                  <p className='max-w-[125px] overflow-hidden text-ellipsis whitespace-nowrap'>
                    {t(texture.zone.replace(/\s*\(.*?\)/, ''))}
                  </p>
                  <div className='-mt-0.5 ml-4'>
                    <p className='max-w-[160px] overflow-hidden text-ellipsis whitespace-nowrap text-[11px]'>
                      {texture.modelo === 'Zocalo'
                        ? texture.modelo
                        : `${texture.modelo ? `${texture.modelo} ` : ''}${texture.acabado ? `${texture.acabado} ` : ''}`}
                    </p>

                    <p className='-mt-1 text-[11px]'>{t(texture.name)} </p>
                  </div>
                  {/* <img
                      src={
                        copiedIconId === texture.zoneName
                          ? dictionary['canCopy']
                          : dictionary['cantCopy']
                      }
                      alt='icon copy'
                      className='m-auto -mt-[1px] mr-2 h-[20px]'
                      onClick={(e) => handleCopy(texture, e)}
                    />
                    <img
                      src={
                        copiedIconId === texture.zoneName
                          ? dictionary['cantPaste']
                          : dictionary[pasteIcon]
                      }
                      alt='icon paste'
                      className='mr-2 h-[20px]'
                      onClick={(e) =>
                        handlePaste(
                          e,
                          { zone: texture.zone, zoneName: texture.zoneName },
                          pasteIcons[texture.zoneDisplayName],
                        )
                      }
                    /> */}
                </div>
              </div>
            )
          })}
        </div>
      </article>
      {children}
    </>
  )
}
